<template>
  <div>
    <draggable
      :disabled="!UD_permissions"
      :list="questions"
      ghost-class="ghost"
      v-bind="dragOptions"
      @change="changeColumn"
    >
      <div v-for="(question, index) in questions" :key="index" class="row mb-3">
        <div class="col-lg-12">
          <div class="position-relative">
            <div
              v-if="UD_permissions"
              class="close radius-0"
              style="right: 0px"
              @click="deleteQuestion(index)"
            >
              <i class="fa fa-times f10" style="margin-bottom: 7px"></i>
            </div>
            <div class="formJov">
              <div v-if="UD_permissions" class="pt-3" style="text-align: left">
                <label class="label-bold">Pergunta por:</label>
                <ul class="nav nav-tabs">
                  <li
                    v-for="tab in questions[index].tabs"
                    :key="tab.name"
                    class="nav-item"
                  >
                    <button
                      :class="tab.active ? 'btn-primary' : 'btn-light bg-white'"
                      class="pointer btn py-2 px-5 radius-0"
                      @click="showTab(tab, index)"
                    >
                      {{ tab.name }}
                    </button>
                  </li>
                </ul>
              </div>
              <div class="card-body p-0 mt-2">
                <div
                  v-if="question.tabs[0].active"
                  :id="question.tabs[0].name"
                  :aria-labelledby="`${question.tabs[0].name}-tab`"
                  :class="{
                    active: question.tabs[0].active,
                    show: question.tabs[0].active,
                    fade: !question.tabs[0].active,
                  }"
                  class="tab-pane"
                >
                  <label>TÍTULO DA PERGUNTA</label>

                  <ckeditor
                    v-model="questions[index].title"
                    :class="{ 'cursor-not-allowed': !UD_permissions }"
                    :config="configCkeditor"
                    :readOnly="!UD_permissions"
                    class="mt-2"
                    placeholder="ADICIONE O TÍTULO DA PERGUNTA"
                    @input="updateQuestions()"
                  />
                  <input
                    v-model="questions[index].details"
                    :class="{ 'cursor-not-allowed': !UD_permissions }"
                    class="mt-3 form-control"
                    placeholder="ADICIONE DETALHES (OPCIONAL)"
                    type="text"
                    @input="updateQuestions()"
                  />
                </div>
                <div
                  v-if="question.tabs[1].active"
                  :id="question.tabs[1].name"
                  :aria-labelledby="`${question.tabs[1].name}-tab`"
                  :class="{
                    active: question.tabs[1].active,
                    show: question.tabs[1].active,
                    fade: !question.tabs[1].active,
                  }"
                  class="tab-pane"
                >
                  <div
                    v-if="
                      question.tabs[1].options.record_now == false &&
                      question.tabs[1].options.upload_video == false
                    "
                    class="row"
                  >
                    <div class="col-lg-12 col-xs-12">
                      <label>TÍTULO DA PERGUNTA</label>
                      <ckeditor
                        v-model="questions[index].title"
                        :class="{ 'cursor-not-allowed': !UD_permissions }"
                        :config="configCkeditor"
                        :readOnly="!UD_permissions"
                        class="mt-2"
                        placeholder="ADICIONE O TÍTULO DA PERGUNTA"
                        @input="updateQuestions()"
                      />
                    </div>
                    <div class="mb-2 col-lg-12 col-xs-12">
                      <div :id="`canvas${index}`" class="hide"></div>
                      <div class="videoPlayCurrent">
                        <video
                          v-show="questions[index].video"
                          :id="`videoQuestion${index}`"
                          class="mt-2"
                          controls
                          controlslist="nodownload"
                          width="100%"
                        >
                          <source :src="questions[index].video" />
                        </video>
                      </div>
                      <transition name="fade">
                        <KProgress
                          v-if="percent > 0 && percent <= 99"
                          :color="['#53358B', '#00baf7']"
                          :percent="percent"
                          bg-color="#fff"
                        />
                      </transition>
                    </div>
                    <div v-if="UD_permissions" class="col-lg-4 col-xs-12">
                      <button
                        class="btn full f13 radius-0 p-2 btn-primary btn-rezise-ask"
                        @click="canVideo(index)"
                      >
                        GRAVAR
                      </button>
                    </div>
                    <div v-if="UD_permissions" class="col-lg-4 col-xs-12">
                      <span
                        :disabled="question.title == ''"
                        class="btn f13 p-2 radius-0 full btn-success btn-default btn-file btn-rezise-ask"
                      >
                        UPLOAD
                        <input
                          :id="`capture${index}`"
                          :ref="`file${index}`"
                          accept="video/*"
                          capture="camcorder"
                          type="file"
                          @click="canUpload(index, $event)"
                          v-on:change="sendMovieUpload(index)"
                        />
                      </span>
                    </div>
                    <div v-if="UD_permissions" class="col-lg-4 col-xs-12">
                      <button
                        :disabled="load"
                        class="btn f13 p-2 radius-0 btn-info full btn-rezise-ask"
                        @click="showSelectVideo(index)"
                      >
                        <span v-show="!load">GALERIA</span>
                        <div
                          v-show="load"
                          class="spinner-border text-light"
                          role="status"
                        >
                          <span class="sr-only"></span>
                        </div>
                      </button>
                    </div>
                  </div>
                </div>
                <div
                  v-if="questions[index].tabs[1].options.record_now == true"
                  class="videoPlayCurrent"
                >
                  <VideoJSRecordGallery
                    v-if="record"
                    :gallery="gallery"
                    :index="index"
                    :item="has_gallery_item(index)"
                    :name="questions[index].title"
                    :question="questions[index]"
                    :video="video_current"
                  />
                  <button
                    class="mt-3 btn-primary btn-sm"
                    @click="backMenuVideo(index)"
                  >
                    <font-awesome-icon class="mr-2" icon="chevron-left" />VOLTAR
                  </button>
                </div>
              </div>
              <div class="row mt-3">
                <div class="col-lg-12">
                  <label
                    >Deseja que a resposta do candidato(a) seja por:
                  </label>
                  <select
                    v-model="questions[index].response_type"
                    class="form-control"
                    @change="updateQuestions(index)"
                  >
                    <option
                      v-for="response in response_types"
                      :key="response.value"
                      :value="response.type"
                    >
                      {{ response.value }}
                    </option>
                  </select>
                </div>
              </div>
              <div v-if="questions[index].response_type == 2" class="row mt-3">
                <MultipleChoices
                  v-model="questions[index].choices"
                  :index="index"
                />
              </div>
              <div v-if="questions[index].response_type == 3" class="row mt-3">
                <YesOrNo v-model="questions[index].choices" :index="index" />
              </div>
              <div v-if="questions[index].response_type == 4" class="mt-3">
                <Monetary v-model="questions[index].choices" :index="index" />
              </div>
              <div v-if="questions[index].response_type == 0" class="row">
                <div class="col-lg-6 col-xs-12 mt-3">
                  <label>NÚMERO DE TENTATIVAS</label>
                  <select
                    v-model="questions[index].number_retakers"
                    :class="{ 'cursor-not-allowed': !UD_permissions }"
                    :readonly="!UD_permissions"
                    class="form-control"
                    @input="updateQuestions()"
                  >
                    <option value="3">3</option>
                    <option value="5">5</option>
                    <option value="7">7</option>
                  </select>
                </div>
                <div class="col-lg-6 col-xs-12 mt-3">
                  <label>TEMPO LIMITE</label>
                  <select
                    v-model="questions[index].time"
                    :class="{ 'cursor-not-allowed': !UD_permissions }"
                    :readonly="!UD_permissions"
                    class="form-control"
                    @input="updateQuestions()"
                  >
                    <option value="30">30 SEGUNDOS</option>
                    <option value="60">60 SEGUNDOS</option>
                    <option value="90">90 SEGUNDOS</option>
                    <option value="120">120 segundos</option>
                    <option value="180">180 segundos</option>
                  </select>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-12">
                  <textarea
                    v-model="questions[index].description"
                    :class="{ 'cursor-not-allowed': !UD_permissions }"
                    :disabled="!UD_permissions"
                    class="form-control mt-3 mb-3 border-radius-pattern"
                    placeholder="DESCRIÇÃO DA PERGUNTA (USO APENAS PARA O RECRUTADOR(A))"
                    rows="3"
                    @input="updateQuestions()"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="UD_permissions" class="row">
        <div class="pr-0 pl-0 col-lg-12 col-xs-12">
          <button
            class="btn mt-3 mb-5 full bg-primary2"
            type="buttom"
            @click="addQuestion"
          >
            <i class="fa fa-plus"></i>
            ADICIONAR A PRÓXIMA PERGUNTA
          </button>
        </div>
        <div class="col-lg-6 col-xs-12"></div>
      </div>
    </draggable>
  </div>
</template>
<script>
import VideoJSRecordGallery from "components/VideoJSRecordGallery.vue";
import KProgress from "k-progress";
import SelectVideo from "@/Recruiters/Galleries/SelectVideo.vue";
import draggable from "vuedraggable";
import MultipleChoices from "@/Recruiters/Questions/MultipleChoices.vue";
import YesOrNo from "@/Recruiters/Questions/YesOrNo.vue";
import Monetary from "@/Recruiters/Questions/Monetary.vue";

export default {
  props: [
    "template_id",
    "questions_record",
    "value",
    "gallery",
    "UD_permissions",
    "intern",
  ],

  components: {
    draggable,
    VideoJSRecordGallery,
    KProgress,
    MultipleChoices,
    YesOrNo,
    Monetary,
  },

  mounted() {
    this.questions = [];
    for (let index in this.questions_record) {
      this.questions.push({
        id: this.questions_record[index].id,
        title: this.questions_record[index].title,
        description: this.questions_record[index].description,
        time: this.questions_record[index].time,
        number_retakers: this.questions_record[index].number_retakers,
        details: this.questions_record[index].details,
        thumbnail: this.questions_record[index].thumbnail,
        video: this.questions_record[index].video,
        template_id: this.template_id,
        video_id: this.questions_record[index].video_id,
        choices: this.questions_record[index].choices,
        gallery_item: this.questions_record[index].gallery_item,
        response_type: this.questions_record[index].response_type,
        tabs: [
          {
            name: "TEXTO",
            active: this.questions_record[index].video_id ? false : true,
          },
          {
            name: "VÍDEO",
            active: this.questions_record[index].video_id ? true : false,
            options: {
              record_now: false,
              upload_video: false,
            },
          },
        ],
      });
    }

    eventBus.$on("updateQuestions", (questions) => {
      for (let index in questions) {
        this.questions.push({
          id: questions[index].id,
          title: questions[index].title,
          description: questions[index].description,
          time: questions[index].time,
          number_retakers: questions[index].number_retakers,
          details: questions[index].details,
          thumbnail: questions[index].thumbnail,
          video: questions[index].video,
          template_id: this.template_id,
          video_id: questions[index].video_id,
          response_type: questions[index].response_type,
          choices: questions[index].choices,
          selective_process_id: this.default_process_id,
          tabs: [
            {
              name: "TEXTO",
              active: questions[index].video_id ? false : true,
            },
            {
              name: "VÍDEO",
              active: questions[index].video_id ? true : false,
              options: {
                record_now: false,
                upload_video: false,
              },
            },
          ],
        });
      }
      this.$emit("input", this.questions);
    });

    eventBus.$on("chooseVideo", (video) => {
      this.questions[video.index].video_id = video.id;
      this.questions[video.index].video = video.video;

      this.$refs["select_video"].modals = [];

      let video_current = document.getElementById(
        `videoQuestion${video.index}`
      );
      video_current.load();
    });
  },
  data: () => ({
    load: false,
    percent: 0,
    file: "",
    video_current: {
      id: 0,
      name: "",
      description: "",
      video: false,
      video_id: 0,
    },
    response_types: [
      { type: 0, value: "Vídeo" },
      { type: 1, value: "Texto" },
      { type: 2, value: "Multipla Escolha" },
      { type: 3, value: "Sim ou não" },
      { type: 4, value: "Válor monetário" },
    ],
    record: true,
    configCkeditor: {
      toolbar: [
        {
          name: "basicstyles",
          groups: ["basicstyles", "cleanup"],
          items: [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "-",
            "RemoveFormat",
            "fontFamily",
            "fontSize",
          ],
        },
        {
          name: "paragraph",
          groups: ["list", "indent", "blocks", "align", "bidi"],
          items: [
            "NumberedList",
            "BulletedList",
            "-",
            "Outdent",
            "Indent",
            "-",
            "Blockquote",
            "CreateDiv",
            "-",
            "JustifyLeft",
            "JustifyCenter",
            "JustifyRight",
            "JustifyBlock",
            "-",
            "BidiLtr",
            "BidiRtl",
            "Language",
          ],
        },
        { name: "tools", items: ["Maximize"] },
        { name: "styles", items: ["FontSize"] },
        { name: "colors", items: ["TextColor", "BGColor"] },
        "/",
      ],
    },
    questions: [
      {
        id: 0,
        title: "",
        description: "",
        time: 30,
        number_retakers: 3,
        details: "",
        video_id: null,
        response_type: 0,
        choices: {},
        tabs: [
          {
            name: "TEXTO",
            active: true,
          },
          {
            name: "VÍDEO",
            active: false,
            options: {
              record_now: false,
              upload_video: false,
            },
          },
        ],
      },
    ],
  }),
  methods: {
    canUpload(index, event) {
      if (this.questions[index].title == "") {
        this.$toast.error("DIGITE UM TÍTULO PARA O VIDEO PARA CONTINUAR");
        event.preventDefault();
      }
    },
    showTab(tab, index) {
      this.backMenuVideo(index);
      if (this.questions[index].video_id) {
        let conf = confirm(
          "AO TROCAR DE ABA O VIDEO SERÁ DELETADO E ESSA PERGUNTA SERÁ USADA COMO A ABA INDICA, VOCÊ DESEJA FAZER ISSO?"
        );
        if (!conf) return;
        axios
          .delete(`/recruiters/question_videos/${this.questions[index].id}`)
          .then((response) => {
            if (!response.data.status) {
              this.$toast.error("ERRO AO DELETAR O VÍDEO");
            }
          });
      }
      for (let i in this.questions[index].tabs) {
        this.questions[index].tabs[i].active = false;
      }
      tab.active = true;
    },
    changeColumn: function (e) {
      eventBus.$emit("saveTemplateQuestions", this.questions);
    },
    async showSelectVideo(index) {
      this.load = true;
      if (this.questions[index].title == "") {
        this.$toast.error("DIGITE UM TÍTULO PARA O VÍDEO PARA CONTINUAR");
        this.load = false;
        return;
      }
      let response = await axios.post("/recruiters/templates/questions", {
        questions: {
          template_id: this.template_id,
          itens: [
            {
              id: this.questions[index].id,
              title: this.questions[index].title,
              description: this.questions[index].description,
              time: this.questions[index].time,
              number_retakers: this.questions[index].number_retakers,
              details: this.questions[index].details,
              template_id: this.questions[index].template_id,
              video_id: this.questions[index].video_id,
              choices: this.questions[index].choices,
              response_type: this.questions[index].response_type,
            },
          ],
        },
      });
      let gallery_item = {
        id: 0,
        name: "",
        description: "",
        reference_id: response.data.question.id,
        category_id: this.gallery.category_id,
        video_id: 0,
      };
      if (this.questions[index].gallery_item)
        gallery_item = this.questions[index].gallery_item;

      if (this.template_id == 0) {
        eventBus.$emit("saveTemplate");
        setTimeout(() => {
          if (this.template_id != 0) {
            let q_current = this.currentQuestionParams(index);

            axios
              .post("/recruiters/templates/questions", {
                questions: {
                  template_id: this.template_id,
                  itens: [q_current],
                },
              })
              .then((response) => {
                this.questions[index].id = response.data.question.id;
                this.$modal.show(
                  SelectVideo,
                  {
                    index,
                    gallery: this.gallery,
                    gallery_item,
                    intern: this.intern,
                  },
                  {
                    width: "75%",
                    height: "auto",
                    scrollable: true,
                  }
                );
                this.load = false;
              });
          } else {
            this.$toast.error(
              "ERRO AO ADICIONAR O VIDEO, TENTE CADASTRAR A VAGA PRIMEIRO."
            );
            this.load = false;
          }
        }, 3600);

        return;
      }

      let q_current = this.currentQuestionParams(index);

      axios
        .post("/recruiters/templates/questions", {
          questions: {
            template_id: this.template_id,
            itens: [q_current],
            gallery: this.gallery,
          },
        })
        .then((response) => {
          this.questions[index].id = response.data.question.id;

          this.$refs["select_video"].modals = [];

          this.$modal.show(
            SelectVideo,
            {
              index,
              gallery: this.gallery,
              gallery_item,
              intern: this.intern,
            },
            {
              width: "75%",
              height: "auto",
              scrollable: true,
            }
          );
        });
      this.load = false;
    },
    currentQuestionParams(index) {
      let q_current = {};
      q_current.id = this.questions[index].id;
      q_current.title = this.questions[index].title;
      q_current.description = this.questions[index].description;
      q_current.time = this.questions[index].time;
      q_current.number_retakers = this.questions[index].number_retakers;
      q_current.details = this.questions[index].details;
      q_current.template_id = this.questions[index].template_id;
      q_current.response_type = this.questions[index].response_type;
      q_current.choices = this.questions[index].choices;
      q_current.video_id = this.questions[index].video_id;
      return q_current;
    },
    sendMovieUpload(index) {
      if (this.questions[index].title == "") {
        this.$toast.error("DIGITE UM TÍTULO PARA O VÍDEO PARA CONTINUAR");
        return;
      }
      let formData = new FormData();
      this.file = this.$refs[`file${index}`][0].files[0];
      formData.append("videos[file]", this.file);
      this.questions[index].video = URL.createObjectURL(this.file);

      let video = document.getElementById(`videoQuestion${index}`);

      video.load();

      video.onloadedmetadata = () => {
        // if (video.duration > 91 || video.duration == Infinity) {
        //   this.load = false;
        //   this.$toast.error(
        //     `Tempo de VÍDEO maior que 3 minutos, por favor grave um VÍDEO menor`
        //   );
        //   return;
        // }

        let q_current = this.currentQuestionParams(index);

        setTimeout(() => {
          let canvas = document.createElement("canvas");
          canvas.className = "hide";

          canvas.width = 320;
          canvas.height = 240;
          document.getElementsByTagName("body")[0].appendChild(canvas);
          canvas
            .getContext("2d")
            .drawImage(video, 0, 0, video.videoWidth, video.videoHeight);
          canvas.toBlob((thumb) => {
            axios
              .post("/recruiters/templates/questions", {
                questions: {
                  template_id: this.template_id,
                  itens: [q_current],
                },
              })
              .then((response) => {
                this.questions[index].id = response.data.question.id;
                formData.append("videos[thumbnail]", thumb);
                formData.append("videos[name]", this.questions[index].title);
                formData.append(
                  "videos[description]",
                  this.questions[index].description
                );
                formData.append("videos[id]", this.questions[index].video_id);

                formData.append(
                  "galleries[gallery_category_id]",
                  this.gallery.category_id
                );

                formData.append(
                  "galleries[reference_id]",
                  this.gallery.reference_id
                );
                formData.append("galleries[name]", this.gallery.name);
                formData.append(
                  "galleries[item_category_id]",
                  this.gallery.item_category_id
                );
                formData.append("galleries[id]", this.gallery.id);
                formData.append(
                  "gallery_item[id]",
                  this.questions[index].gallery_item
                    ? this.questions[index].gallery_item.id
                    : null
                );
                formData.append(
                  "gallery_item[reference_id]",
                  this.questions[index].id
                );

                axios
                  .post(
                    "/recruiters/galleries/videos?no_replace=true",
                    formData,
                    {
                      headers: {
                        "Content-Type": "multipart/form-data",
                      },
                      onUploadProgress: (progressEvent) => {
                        const totalLength = progressEvent.lengthComputable
                          ? progressEvent.total
                          : progressEvent.target.getResponseHeader(
                              "content-length"
                            ) ||
                            progressEvent.target.getResponseHeader(
                              "x-decompressed-content-length"
                            );

                        if (totalLength !== null) {
                          this.percent = parseInt(
                            (progressEvent.loaded * 100) / totalLength
                          );
                        }
                      },
                    }
                  )
                  .then((resp) => {
                    if (
                      this.gallery.item_category_id == 5 &&
                      this.gallery.reference_id != 0
                    ) {
                      this.$emit("setFieldGalleryItem", resp);
                      return;
                    }
                    eventBus.$emit("setFieldVideo", {
                      gallery_item: resp.data.gallery_item,
                      video: resp.data.video,
                    });
                  })
                  .catch(function (error) {
                    console.log(error);
                  });
              });
          });
        }, 1100);
      };
    },
    deleteQuestion(index) {
      if (this.questions[index].id != 0) {
        let conf = confirm("TEM CERTEZA QUE DESEJA DELETAR ESSA PERGUNTA?");
        if (!conf) return;
        axios
          .delete(`/recruiters/templates/questions/${this.questions[index].id}`)
          .then((response) => {
            this.$toast.success("PERGUNTA REMOVIDA COM SUCESSO", {
              position: "top",
            });
          })
          .catch((error) => {
            console.log(error);
            this.$toast.error("PERGUNTA NÃO PODE SER EXCLUÍDA", {
              position: "top",
            });
          });
      }
      this.questions.splice(index, 1);
    },
    addQuestion() {
      this.questions.push({
        id: 0,
        title: "",
        description: "",
        time: 30,
        number_retakers: 3,
        template_id: this.template_id,
        video: "",
        response_type: 0,
        choices: {},
        tabs: [
          {
            name: "TEXTO",
            active: true,
          },
          {
            name: "VÍDEO",
            active: false,
            options: {
              record_now: false,
              upload_video: false,
            },
          },
        ],
      });
    },
    canVideo(index, page = "record_now") {
      if (this.questions[index].title == "") {
        this.$toast.error("DIGITE UM TÍTULO DO  VÍDEO PARA CONTINUAR");
        return;
      }

      // if (!this.template_id) {
      //   // eventBus.$emit("saveJob", { index: index });

      //   // setTimeout(() => {
      //   //   if (!this.template_id) {
      this.backMenuVideo(index);
      //   //   }
      //   // }, 1100);
      // }
      if (page) this.questions[index].tabs[1].options[page] = true;
    },
    backMenuVideo(index) {
      this.questions[index].tabs[1].options.record_now = false;
      this.questions[index].tabs[1].options.upload_video = false;
    },
    updateQuestions(index = false) {
      if (index || index === 0) {
        let question = this.questions[index];
        this.questions[index].choices = {};
      }

      this.$emit("input", this.questions);
    },
    has_gallery_item(index) {
      if (this.questions[index].gallery_item)
        return this.questions[index].gallery_item;

      return { id: null, video_id: 0 };
    },
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
};
</script>
